import { z } from 'zod'

export const FinalSituationSchema = (args) => {
	return z
		.object({
			disability: z
				.object({
					type: z.string(),
					biologicalDamage: z.number().optional(),
					predictedPPD: z.number().optional(),
					PPDWeight: z.number().optional(),
					PTDOW: z.boolean().optional(),
					needForAdditionalEfforts: z.boolean().optional(),
				})
				.strict()
				.refine(
					(data) =>
						data?.type !== 'ACCD' ||
						[
							'WORK_RELATED',
							'SPORTS_ACCIDENT',
							'LIFE_INSURANCE',
						].includes(args?.accidentSegmentId) ||
						!!data?.biologicalDamage ||
						`${data?.biologicalDamage}`.match(
							new RegExp('^100$|^[0-9]{1,2}([.][0-9]{1,2})?%?$')
						),
					{
						message: 'must be a number between 0 and 100!',
						path: ['disability', 'biologicalDamage'],
					}
				)
				.refine(
					(data) =>
						data?.type !== 'ACCD' ||
						![
							'WORK_RELATED',
							'SPORTS_ACCIDENT',
							'LIFE_INSURANCE',
						].includes(args?.accidentSegmentId) ||
						!!data?.predictedPPD ||
						`${data?.predictedPPD}`.match(
							new RegExp('^100$|^[0-9]{1,2}([.][0-9]{1,2})?%?$')
						),
					{
						message: 'wrong format or greater than 100!',
						path: ['disability', 'predictedPPD'],
					}
				)
				.refine(
					(data) =>
						data?.type !== 'ACCD' ||
						![
							'WORK_RELATED',
							'SPORTS_ACCIDENT',
							'LIFE_INSURANCE',
						].includes(args?.accidentSegmentId) ||
						!data?.PPDWeight ||
						data?.PPDWeight > 0,
					{
						message: 'Required',
						path: ['disability', 'PPDWeight'],
					}
				)
				.refine(
					(data) =>
						data?.type !== 'ACCD' ||
						[true, false].includes(data?.PTDOW),
					{
						message: 'Required',
						path: ['disability', 'PTDOW'],
					}
				)
				.refine(
					(data) =>
						data?.type !== 'ACCD' ||
						[true, false].includes(data?.needForAdditionalEfforts),
					{
						message: 'Required',
						path: ['disability', 'needForAdditionalEfforts'],
					}
				),
			treatmentDays: z
				.number()
				.transform((val) =>
					val !== null ? parseInt(val, 10) : undefined
				)
				.refine(
					(treatmentDays) =>
						treatmentDays - args.lastClinicalEpisode > 0,
					{
						message: 'must be higher than 0.',
						path: ['remainingDays'],
					}
				),
			ttd: z
				.object({
					totalDays: z
						.number()
						.transform((val) =>
							val !== null ? parseInt(val, 10) : undefined
						),
					justification: z.string().min(1),
				})
				.strict(),
			timeBeforeNextEvaluation: z
				.string()
				.transform((val) =>
					val !== null ? parseInt(val, 10) : undefined
				),
		})
		.strict()
}
